import { errorMessage, needsIdempotency, type ErrorPayload } from './api-contract.js';

export type ApiEnvelope<T> = { data: T; requestId: string };

export class ApiError extends Error {
  constructor(public readonly status: number, message: string) {
    super(message);
  }
}

export function getToken(): string | null {
  return localStorage.getItem('after-sales-erp-token');
}

export function setToken(token: string | null): void {
  if (token) localStorage.setItem('after-sales-erp-token', token);
  else localStorage.removeItem('after-sales-erp-token');
  window.dispatchEvent(new Event('erp-auth-change'));
}

export type ApiOptions = RequestInit & { idempotencyKey?: string };

export async function api<T>(path: string, options: ApiOptions = {}): Promise<T> {
  const token = getToken();
  const { idempotencyKey, ...requestOptions } = options;
  const method = requestOptions.method ?? 'GET';
  const response = await fetch(`/api/v1${path}`, {
    ...requestOptions,
    headers: {
      'content-type': 'application/json',
      ...(token ? { authorization: `Bearer ${token}` } : {}),
      ...(needsIdempotency(method, path) ? { 'idempotency-key': idempotencyKey ?? crypto.randomUUID() } : {}),
      ...requestOptions.headers
    }
  });
  const payload = await response.json().catch(() => ({})) as ErrorPayload & { data?: T };
  if (!response.ok) {
    if (response.status === 401 && token) setToken(null);
    throw new ApiError(response.status, errorMessage(payload, response.status));
  }
  if (!Object.prototype.hasOwnProperty.call(payload, 'data') || payload.data === undefined) {
    throw new ApiError(response.status, '接口返回的数据不完整，请刷新后重试');
  }
  return payload.data as T;
}
